import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import AuthGate from './AuthGate.js';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthGate><App /></AuthGate>
  </StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js'); });
}
